import { IDate } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { Button, DatePicker, Flex, Form, FormInstance, Modal } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { TimeZoneSelector } from '@/components/Form';
import { RULES } from '@/constants';

type Props = {
  isOpen: boolean;
  isEditingScheduledPost: boolean;
  isPending: boolean;
  scheduleForm: FormInstance;
  onSubmit: (values: IDate) => void;
  onCancel: () => void;
};

export const SchedulingModal: React.FC<Props> = ({
  isOpen,
  isEditingScheduledPost,
  isPending,
  scheduleForm,
  onSubmit,
  onCancel
}) => {
  const { t } = useTranslation('CommonDashboardTranslations');

  return (
    <Modal
      open={isOpen}
      centered
      onCancel={onCancel}
      title={t('SCHEDULE_POST')}
      footer={null}
      width={500}>
      <Form
        form={scheduleForm}
        onFinish={(raw: { dateTime: Dayjs; timeZone: string }) => {
          onSubmit({
            dateTime: dayjs.tz(raw.dateTime, raw.timeZone).format('YYYY-MM-DDTHH:mm:ss'),
            timeZone: raw.timeZone
          });
        }}
        layout="vertical">
        <Form.Item
          getValueProps={value => ({ value: value ? dayjs(value) : undefined })}
          label={t('SCHEDULE_POST_DATE')}
          rules={[RULES.REQUIRED]}
          name="dateTime">
          <DatePicker
            style={{ width: '100%' }}
            format="DD/MM/YYYY HH:mm"
            showTime={{ format: 'HH:mm' }}
            disabledDate={date => dateProvider.isBeforeToday(date.toDate())}
          />
        </Form.Item>
        <Form.Item label={t('SCHEDULE_POST_TIMEZONE')} rules={[RULES.REQUIRED]} name="timeZone">
          <TimeZoneSelector />
        </Form.Item>
        <Flex justify="flex-end" gap={8}>
          <Button onClick={onCancel}>{t('CANCEL')}</Button>
          <Button type="primary" htmlType="submit" loading={isPending}>
            {isEditingScheduledPost ? t('SAVE') : t('SCHEDULE_POST')}
          </Button>
        </Flex>
      </Form>
    </Modal>
  );
};
